import { useCallback, useEffect, useState } from 'react';
import type { Priorite } from '../partage/api/types';

/**
 * La priorité mise en avant par le calque (ticket 04 du chantier `priorites`) : un état de
 * l'écran, jamais stocké. Comme la profondeur (`profondeurDuDossier.ts`), il tient **tant
 * qu'on reste dans le dossier**, en entrant dans une étape ou en passant de la Carte à la
 * Hiérarchie, et repart à « aucune » dans un autre dossier.
 */
interface Etat {
  dossier: string | undefined;
  enAvant: Priorite | null;
}

/** Tant que la feuille se lit (`undefined`), on garde ce qu'on a : c'est peut-être le même dossier. */
function duDossier(avant: Etat, dossierId: string | undefined): Etat {
  if (dossierId === undefined || avant.dossier === dossierId) return avant;
  if (avant.dossier === undefined) return { ...avant, dossier: dossierId };
  return { dossier: dossierId, enAvant: null };
}

export function useCalque(dossierId: string | undefined) {
  const [etat, setEtat] = useState<Etat>({ dossier: dossierId, enAvant: null });

  useEffect(() => {
    setEtat((avant) => duDossier(avant, dossierId));
  }, [dossierId]);

  const choisir = useCallback(
    (enAvant: Priorite | null) => setEtat((avant) => ({ ...duDossier(avant, dossierId), enAvant })),
    [dossierId]
  );

  return { enAvant: duDossier(etat, dossierId).enAvant, choisir };
}
